import React from "react";
import { Daisy } from "./decor/Daisy";
import { brandAssets } from "../data/offer";
const closingLines = ["Une parabole aujourd’hui.", "Une conversation demain.", "Et de précieux moments à garder dans le cœur."];
export function EmotionalSection() {
  return <section className="relative overflow-hidden bg-royal text-white" data-id="element-86" data-mp="3eftlr19ij5pi">
      <Daisy className="pointer-events-none absolute left-6 top-8 w-10 opacity-90" data-id="element-87" data-mp="3eg3c4pygzevq" />
      <Daisy className="pointer-events-none absolute bottom-10 right-8 w-12 opacity-90" data-id="element-88" data-mp="60joc6gkioo2" />
      <div className="mx-auto max-w-6xl px-5 py-20 md:py-28" data-id="element-89" data-mp="axtmqblxqao1">
        <h2 className="mx-auto max-w-4xl text-center font-display text-[2rem] font-bold leading-[1.12] md:text-5xl md:leading-[1.08]" data-id="element-90" data-mp="3t4zrz96rpw6w">
          Bien plus que des histoires…{" "}
          <span className="text-sun" data-id="element-91" data-mp="209fmm1e5k5i">des souvenirs de foi à créer ensemble.</span>
        </h2>

        <div className="mt-12 grid items-center gap-10 md:mt-16 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-92" data-mp="2hrxckhgencob">
          <div className="mx-auto w-full max-w-[420px] rounded-full bg-white/10 p-4" data-id="element-93" data-mp="2mmb428ry4znp">
            <img src={brandAssets.logo} alt="Jésus lit la Bible avec un petit garçon et une petite fille — logo Petites Histoires, Grande Foi" className="w-full drop-shadow-[0_12px_24px_rgba(0,0,0,0.25)]" data-id="element-94" data-mp="2oxaqsud1uqws" />
          </div>
          <div className="text-center lg:text-left" data-id="element-95" data-mp="2tsq1xejoa8pi">
            <p className="text-lg leading-relaxed text-white/95 md:text-xl" data-id="element-96" data-mp="37tsr405yrz4n">
              Un enfant n’a pas besoin d’une leçon parfaite pour découvrir la foi. Il a surtout
              besoin de moments de partage, de questions accueillies avec amour et de petites
              expériences qui donnent du sens aux enseignements de la Bible.
            </p>
            <p className="mt-10 font-display text-2xl font-bold leading-snug md:text-[2rem]" data-id="element-97" data-mp="3clkfq55k7us5">
              {closingLines.map((line, i) => <span key={line} className={`block ${i === closingLines.length - 1 ? "text-sun" : ""}`} data-id="element-98" data-mp="3mji5ix32hzmv" data-mpi={i}>
                  {line}
                </span>)}
            </p>
          </div>
        </div>
      </div>
    </section>;
}